/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const rentSizeAvailability = /* GraphQL */ `
  query RentSizeAvailability(
    $appInstance: String!
    $mobVersion: Int!
    $pointSellId: String!
    $productId: String!
    $dateFrom: AWSDateTime!
    $dateTo: AWSDateTime!
  ) {
    rentSizeAvailability(
      appInstance: $appInstance
      mobVersion: $mobVersion
      pointSellId: $pointSellId
      productId: $productId
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      appInstance
      mobVersion
      productId
      size
      sizeUnit
      articleCountTotalSum
    }
  }
`;
export const rentArticleAvailability = /* GraphQL */ `
  query RentArticleAvailability(
    $appInstance: String!
    $mobVersion: Int!
    $pointSellId: String!
    $productId: String!
    $dateFrom: AWSDateTime!
    $dateTo: AWSDateTime!
    $size: String!
  ) {
    rentArticleAvailability(
      appInstance: $appInstance
      mobVersion: $mobVersion
      pointSellId: $pointSellId
      productId: $productId
      dateFrom: $dateFrom
      dateTo: $dateTo
      size: $size
    ) {
      id
      mobVersion
      mssId
      appInstance
      articleType
      productId
      locationId
      pointSellId
      title
      description
      articleCountTotal
      articleNumber
      articleNumber2
      size
      sizeUnit
    }
  }
`;
export const schoolListVariants = /* GraphQL */ `
  query SchoolListVariants(
    $appInstance: String!
    $mobVersion: Int!
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
    $locationMssId: Int!
    $skillMssId: Int!
    $languageCodes: [String]
    $requestedLengthTotal: Int!
    $requestedLengthAvg: Int!
    $candidateSlots: [CandidateSlotIn]!
  ) {
    schoolListVariants(
      appInstance: $appInstance
      mobVersion: $mobVersion
      dateFrom: $dateFrom
      dateTo: $dateTo
      locationMssId: $locationMssId
      skillMssId: $skillMssId
      languageCodes: $languageCodes
      requestedLengthTotal: $requestedLengthTotal
      requestedLengthAvg: $requestedLengthAvg
      candidateSlots: $candidateSlots
    )
  }
`;
export const schoolListFreeSlots = /* GraphQL */ `
  query SchoolListFreeSlots(
    $appInstance: String!
    $mobVersion: Int!
    $dateFrom: AWSDate!
    $dateTo: AWSDate!
    $variantIds: [Int!]!
    $candidateSlots: [CandidateSlotIn]!
  ) {
    schoolListFreeSlots(
      appInstance: $appInstance
      mobVersion: $mobVersion
      dateFrom: $dateFrom
      dateTo: $dateTo
      variantIds: $variantIds
      candidateSlots: $candidateSlots
    ) {
      timeFrom
      timeTo
      subjectMssId
      sganttWorkDayMssId
    }
  }
`;
export const getRentProductRequirement = /* GraphQL */ `
  query GetRentProductRequirement($id: ID!) {
    getRentProductRequirement(id: $id) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
    }
  }
`;
export const listRentProductRequirements = /* GraphQL */ `
  query ListRentProductRequirements(
    $filter: ModelRentProductRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentProductRequirements(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        rentProductType
        nameDisplayed
        nameRequired
        sexDisplayed
        sexRequired
        ageDisplayed
        ageRequired
        weightDisplayed
        weightRequired
        heightDisplayed
        heightRequired
        shoeSizeDisplayed
        shoeSizeRequired
        rentAbilityLevelDisplayed
        rentAbilityLevelRequired
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listRentProductRequirementByAppInstance = /* GraphQL */ `
  query ListRentProductRequirementByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRentProductRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRentProductRequirementByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        rentProductType
        nameDisplayed
        nameRequired
        sexDisplayed
        sexRequired
        ageDisplayed
        ageRequired
        weightDisplayed
        weightRequired
        heightDisplayed
        heightRequired
        shoeSizeDisplayed
        shoeSizeRequired
        rentAbilityLevelDisplayed
        rentAbilityLevelRequired
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMOBConfig = /* GraphQL */ `
  query GetMOBConfig($id: ID!) {
    getMOBConfig(id: $id) {
      id
      mobVersion
      groups
      appInstance
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      createdAt
      updatedAt
    }
  }
`;
export const listMOBConfigs = /* GraphQL */ `
  query ListMOBConfigs(
    $filter: ModelMOBConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMOBConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        enabled
        enabledSchool
        enabledRent
        companyName
        title
        schoolHeader
        rentHeader
        schoolClaim
        rentClaim
        rentVop
        schoolVop
        schoolBookingOffset
        rentBookingOffset
        checkoutTimeLimit
        showPriceWithoutDPH
        rentDiscountPercent
        schoolDiscountPercent
        email
        phone
        emailNotifLogoUrl
        websiteUrl
        webLogoUrl
        webLogoSmallUrl
        webHeroBgImgUrl
        productImageRatio
        paymentMethods
        currency
        cartStaticInfo
        checkoutStaticInfo
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listMOBConfigsByAppInstance = /* GraphQL */ `
  query ListMOBConfigsByAppInstance(
    $appInstance: String
    $sortDirection: ModelSortDirection
    $filter: ModelMOBConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMOBConfigsByAppInstance(
      appInstance: $appInstance
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        enabled
        enabledSchool
        enabledRent
        companyName
        title
        schoolHeader
        rentHeader
        schoolClaim
        rentClaim
        rentVop
        schoolVop
        schoolBookingOffset
        rentBookingOffset
        checkoutTimeLimit
        showPriceWithoutDPH
        rentDiscountPercent
        schoolDiscountPercent
        email
        phone
        emailNotifLogoUrl
        websiteUrl
        webLogoUrl
        webLogoSmallUrl
        webHeroBgImgUrl
        productImageRatio
        paymentMethods
        currency
        cartStaticInfo
        checkoutStaticInfo
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStaticContent = /* GraphQL */ `
  query GetStaticContent($id: ID!) {
    getStaticContent(id: $id) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
    }
  }
`;
export const listStaticContents = /* GraphQL */ `
  query ListStaticContents(
    $filter: ModelStaticContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaticContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        title
        icon
        isExternal
        linkUrl
        content
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listStaticContentByAppInstance = /* GraphQL */ `
  query ListStaticContentByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStaticContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaticContentByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        title
        icon
        isExternal
        linkUrl
        content
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSkill = /* GraphQL */ `
  query GetSkill($id: ID!) {
    getSkill(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listSkills = /* GraphQL */ `
  query ListSkills(
    $filter: ModelSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listSkillsByAppInstance = /* GraphQL */ `
  query ListSkillsByAppInstance(
    $appInstance: String
    $sortDirection: ModelSortDirection
    $filter: ModelSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkillsByAppInstance(
      appInstance: $appInstance
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      enabledFrom
      enabledTo
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      schoolFormType
      schoolAgeGroups
      schoolSkillLevelClients
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      createdAt
      updatedAt
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listProductsByAppInstance = /* GraphQL */ `
  query ListProductsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCategorysByAppInstance = /* GraphQL */ `
  query ListCategorysByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategorysByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCategoriesByProductType = /* GraphQL */ `
  query ListCategoriesByProductType(
    $appInstance: String
    $mobVersionProductType: ModelCategoryListCategoriesByProductTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesByProductType(
      appInstance: $appInstance
      mobVersionProductType: $mobVersionProductType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        nextToken
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listLocationsByAppInstance = /* GraphQL */ `
  query ListLocationsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getPointSell = /* GraphQL */ `
  query GetPointSell($id: ID!) {
    getPointSell(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      openHoursMondayFrom
      openHoursMondayTo
      openHoursTuesdayFrom
      openHoursTuesdayTo
      openHoursWednesdayFrom
      openHoursWednesdayTo
      openHoursThursdayFrom
      openHoursThursdayTo
      openHoursFridayFrom
      openHoursFridayTo
      openHoursSaturdayFrom
      openHoursSaturdayTo
      openHoursSundayFrom
      openHoursSundayTo
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listPointSells = /* GraphQL */ `
  query ListPointSells(
    $filter: ModelPointSellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSells(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listPointSellsByAppInstance = /* GraphQL */ `
  query ListPointSellsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointSellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getPointMeeting = /* GraphQL */ `
  query GetPointMeeting($id: ID!) {
    getPointMeeting(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const listPointMeetings = /* GraphQL */ `
  query ListPointMeetings(
    $filter: ModelPointMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointMeetings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listPointMeetingsByAppInstance = /* GraphQL */ `
  query ListPointMeetingsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointMeetingsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getSet = /* GraphQL */ `
  query GetSet($id: ID!) {
    getSet(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listSets = /* GraphQL */ `
  query ListSets(
    $filter: ModelSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listSetsByAppInstance = /* GraphQL */ `
  query ListSetsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSetsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getArticle = /* GraphQL */ `
  query GetArticle($id: ID!) {
    getArticle(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      articleType
      productId
      pointSellId
      title
      description
      articleCountTotal
      articleNumber
      articleNumber2
      size
      sizeUnit
      rentLevel
      rentAgeGroup
      rentGender
      aggItem
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const listArticles = /* GraphQL */ `
  query ListArticles(
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listArticlesByAppInstance = /* GraphQL */ `
  query ListArticlesByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticlesByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listArticlesByProduct = /* GraphQL */ `
  query ListArticlesByProduct(
    $productId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticlesByProduct(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listArticlesByPointSell = /* GraphQL */ `
  query ListArticlesByPointSell(
    $pointSellId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticlesByPointSell(
      pointSellId: $pointSellId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listArticlesByProductAndSize = /* GraphQL */ `
  query ListArticlesByProductAndSize(
    $productId: ID
    $size: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticlesByProductAndSize(
      productId: $productId
      size: $size
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listArticlesByProductAndPointSell = /* GraphQL */ `
  query ListArticlesByProductAndPointSell(
    $productId: ID
    $pointSellId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticlesByProductAndPointSell(
      productId: $productId
      pointSellId: $pointSellId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getSubject = /* GraphQL */ `
  query GetSubject($id: ID!) {
    getSubject(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      owner
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listSubjects = /* GraphQL */ `
  query ListSubjects(
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listSubjectsByAppInstance = /* GraphQL */ `
  query ListSubjectsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjectsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      createdAt
      updatedAt
      owner
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        mssOrderrId
        paymentMethod
        paymentState
        amount
        currency
        transId
        redirectUrl
        createdAt
        updatedAt
        owner
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const listPaymentsByAppInstance = /* GraphQL */ `
  query ListPaymentsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        mssOrderrId
        paymentMethod
        paymentState
        amount
        currency
        transId
        redirectUrl
        createdAt
        updatedAt
        owner
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getPaymentByTransId = /* GraphQL */ `
  query GetPaymentByTransId(
    $transId: String
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getPaymentByTransId(
      transId: $transId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        mssOrderrId
        paymentMethod
        paymentState
        amount
        currency
        transId
        redirectUrl
        createdAt
        updatedAt
        owner
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const getOrderr = /* GraphQL */ `
  query GetOrderr($id: ID!) {
    getOrderr(id: $id) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listOrderrs = /* GraphQL */ `
  query ListOrderrs(
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrderrsByAppInstance = /* GraphQL */ `
  query ListOrderrsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrderrsByBookingState = /* GraphQL */ `
  query ListOrderrsByBookingState(
    $appInstance: String
    $mobVersionBookingState: ModelOrderrListOrderrsByBookingStateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrsByBookingState(
      appInstance: $appInstance
      mobVersionBookingState: $mobVersionBookingState
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrderrsByBookingStateAndExpireAt = /* GraphQL */ `
  query ListOrderrsByBookingStateAndExpireAt(
    $bookingState: BookingState
    $expireAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrsByBookingStateAndExpireAt(
      bookingState: $bookingState
      expireAt: $expireAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getOrderrItemGroup = /* GraphQL */ `
  query GetOrderrItemGroup($id: ID!) {
    getOrderrItemGroup(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfile {
        name
        weight
        height
        shoeSize
        age
        gender
        rentAbilityLevel
      }
      description
      itemsCount
      numberOfPersons
      length
      priceListType
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const listOrderrItemGroups = /* GraphQL */ `
  query ListOrderrItemGroups(
    $filter: ModelOrderrItemGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItemGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfile {
          name
          weight
          height
          shoeSize
          age
          gender
          rentAbilityLevel
        }
        description
        itemsCount
        numberOfPersons
        length
        priceListType
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          createdAt
          updatedAt
          products {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        owner
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrderrItemGroupsByAppInstance = /* GraphQL */ `
  query ListOrderrItemGroupsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrItemGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItemGroupsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfile {
          name
          weight
          height
          shoeSize
          age
          gender
          rentAbilityLevel
        }
        description
        itemsCount
        numberOfPersons
        length
        priceListType
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          createdAt
          updatedAt
          products {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        owner
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getOrderrItem = /* GraphQL */ `
  query GetOrderrItem($id: ID!) {
    getOrderrItem(id: $id) {
      id
      mobVersion
      groups
      appInstance
      language
      skillLevelClient
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
      }
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      article {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfile {
          name
          weight
          height
          shoeSize
          age
          gender
          rentAbilityLevel
        }
        description
        itemsCount
        numberOfPersons
        length
        priceListType
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          createdAt
          updatedAt
          products {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        owner
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
export const listOrderrItems = /* GraphQL */ `
  query ListOrderrItems(
    $filter: ModelOrderrItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mobVersion
        groups
        appInstance
        language
        skillLevelClient
        sameInstructorRequired
        numberOfHoursRequired
        lessons {
          mobVersion
          groups
          appInstance
          mssId
          timeFrom
          timeTo
          timeLength
          mssWorkDayId
        }
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        article {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        orderrItemGroup {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
export const listOrderrItemsByAppInstance = /* GraphQL */ `
  query ListOrderrItemsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderrItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderrItemsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        language
        skillLevelClient
        sameInstructorRequired
        numberOfHoursRequired
        lessons {
          mobVersion
          groups
          appInstance
          mssId
          timeFrom
          timeTo
          timeLength
          mssWorkDayId
        }
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        article {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        orderrItemGroup {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        owner
      }
      nextToken
    }
  }
`;
